// Google Ads 전환 추적 유틸리티

// gtag 타입 정의
declare global {
  interface Window {
    gtag?: (
      command: 'config' | 'event' | 'js',
      targetId: string | Date,
      config?: Record<string, any>
    ) => void;
    dataLayer?: any[];
  }
}

/**
 * Google Ads 전환 이벤트를 추적합니다.
 * 
 * @param conversionId - 전환 ID (예: 'AW-469441028/pdcWCIXw9KkbEIS07N8B')
 * @param additionalData - 추가 데이터 (선택사항)
 * 
 * @example
 * // 회원가입 전환 추적
 * trackConversion('AW-469441028/pdcWCIXw9KkbEIS07N8B', {
 *   value: 1.0,
 *   currency: 'KRW'
 * });
 */
export function trackConversion(
  conversionId: string,
  additionalData?: Record<string, any>
): void {
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: conversionId,
        ...additionalData,
      });
      console.log('[Google Ads] 전환 추적됨:', conversionId, additionalData);
    } else {
      console.warn('[Google Ads] gtag 함수를 찾을 수 없습니다.');
    }
  } catch (error) {
    console.error('[Google Ads] 전환 추적 오류:', error);
  }
}

/**
 * 웹사이트 트래픽 전환 추적
 * 회원가입 성공, 중요한 액션 완료 시 호출
 */
export function trackWebsiteTrafficConversion(additionalData?: Record<string, any>): void {
  trackConversion('AW-469441028/pdcWCIXw9KkbEIS07N8B', additionalData);
}

/**
 * 사용자 정의 이벤트 추적
 * 
 * @param eventName - 이벤트 이름
 * @param eventParams - 이벤트 파라미터
 */
export function trackEvent(
  eventName: string,
  eventParams?: Record<string, any>
): void {
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventParams);
      console.log('[Google Ads] 이벤트 추적됨:', eventName, eventParams);
    } else {
      console.warn('[Google Ads] gtag 함수를 찾을 수 없습니다.');
    }
  } catch (error) {
    console.error('[Google Ads] 이벤트 추적 오류:', error);
  }
}

